import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { find as _find } from 'lodash';
import Modal from 'components/Modal';

import { addNotification } from 'actions/NotificationsActions';

import SocialMediaLoginSecretNewForm from 'components/forms/whiteLabel/SocialMediaLoginSecretNewForm';
import SocialMediaLoginSecretEditForm from 'components/forms/whiteLabel/SocialMediaLoginSecretEditForm';

class SocialMediaLoginSecret extends React.Component {
  getTitle = () => {
    const { type } = this.props;

    switch (type) {
      case 'facebookSecret':
        return 'Facebook App Secret';

      case 'googleSecret':
        return 'Google App Secret';

      case 'facebookPageAccessToken':
        return 'Facebook Page Access Token';

      case 'stripeSecret':
        return 'Stripe Secret Key';
    }
  };

  getSavedToastMessage = () => {
    const { intl, type } = this.props;

    if (type === 'facebookPageAccessToken') {
      return intl.messages.page_access_token_saved;
    }

    return intl.messages.app_secret_saved;
  };

  componentDidUpdate = prevProps => {
    const { show, formStatusNew, formStatusEdit, close, doNotify } = this.props;

    if (show && prevProps.formStatusNew.pending && !formStatusNew.pending && !formStatusNew.hasError) {
      close();
      doNotify(1, this.getSavedToastMessage());
    }

    if (show && prevProps.formStatusEdit.pending && !formStatusEdit.pending && !formStatusEdit.hasError) {
      close();
      doNotify(1, this.getSavedToastMessage());
    }
  };

  render() {
    const { show, close, socialMediaLoginSecrets, type, whiteLabelId } = this.props;

    const socialMediaLoginSecret = _find(socialMediaLoginSecrets, ['type', type]);

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{this.getTitle()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {socialMediaLoginSecret ? (
            <SocialMediaLoginSecretEditForm socialMediaLoginSecret={socialMediaLoginSecret} />
          ) : (
            <SocialMediaLoginSecretNewForm socialMediaLoginSecret={{ type }} whiteLabelId={whiteLabelId} />
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatusNew: state.formStatus.socialMediaLoginSecretNew,
    formStatusEdit: state.formStatus.socialMediaLoginSecretEdit,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SocialMediaLoginSecret)
  )
);
